import { AuthenticationClient } from "@feathersjs/authentication-client";
import Cookies from "js-cookie";
import { B3_AUTH_COOKIE_NAME } from "./shared/constants/index.js";
import { getSessionDurationDays } from "./shared/utils/session-duration.js";
/** Default API URL derived from environment variables. */
export const B3_API_URL = process.env.EXPO_PUBLIC_B3_API || process.env.NEXT_PUBLIC_B3_API || process.env.PUBLIC_B3_API || "https://api.b3.fun";
/**
 * Runtime-overridable API URL. Set by `B3Provider` when an `apiUrl` prop
 * is provided. Falls back to the env-var-derived `B3_API_URL`.
 */
let _apiUrlOverride = null;
/**
 * Override the B3 API URL at runtime. Called by `B3Provider` when an
 * `apiUrl` prop is provided. Pass `null` to revert to the default.
 */
export function setB3ApiUrl(url) {
    _apiUrlOverride = url;
}
/** Get the current B3 API URL (prefers runtime override, then env var). */
export function getB3ApiUrl() {
    return _apiUrlOverride || B3_API_URL;
}
export const authenticate = async (app, accessToken, identityToken, params) => {
    const fullToken = `${accessToken}+${identityToken}`;
    // Do not authenticate if there is no token
    if (!fullToken) {
        console.log("No token found, not authenticating");
        return null;
    }
    try {
        const response = await app.authenticate({
            strategy: "jwt",
            accessToken: fullToken,
        }, {
            query: params || {},
        });
        const token = Cookies.get(B3_AUTH_COOKIE_NAME);
        if (token) {
            const days = getSessionDurationDays(response?.user?.preferences, params?.partnerId);
            Cookies.set(B3_AUTH_COOKIE_NAME, token, {
                ...(days > 0 ? { expires: days } : {}),
                secure: true,
                sameSite: "Lax",
            });
        }
        return response;
    }
    catch (error) {
        return null;
    }
};
export class MyAuthenticationClient extends AuthenticationClient {
    getFromLocation(location) {
        // Do custom location things here
        return super.getFromLocation(location);
    }
}
export const clientOptions = {
    Authentication: MyAuthenticationClient,
    jwtStrategy: "jwt",
    storage: {
        getItem: (key) => {
            return Cookies.get(key);
        },
        setItem: (key, value) => {
            Cookies.set(key, value);
        },
        removeItem: (key) => {
            Cookies.remove(key);
        },
    },
    storageKey: B3_AUTH_COOKIE_NAME,
};
